// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__24FrS","col":"Table_col__3ycMt","fulfillmentStatus":"Table_fulfillmentStatus__2L7LZ","emailCol":"Table_emailCol__2nkZQ"};